import { DOCUMENT } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import { Component, Inject, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { HealthInsurancePatientModel } from "src/app/core/models/health-insurance-patient";
import { HealthInsurancePlanModel } from "src/app/core/models/health-insurance-plan.model";
import { HealthInsuranceModel } from "src/app/core/models/health-insurance.model";
import { PatientModel } from "src/app/core/models/patient.model";
import { PhoneModel } from "src/app/core/models/phone.model";
import { BrapiService } from "src/app/core/services/brapi.service";
import { ClinicsService } from "src/app/core/services/clinics.service";
import { ProfessionalsService } from "src/app/core/services/professionals.service";
import { ProfessionsService } from "src/app/core/services/professions.service";
import { RegistersService } from "src/app/core/services/registers.service";
import { OptionsSelectModel } from "src/app/shared/models/option";

@Component({
  selector: 'app-patient-register',
  templateUrl: './patient-register.component.html',
  styleUrls: ['./patient-register.component.scss']
})
export class PatientRegisterComponent implements OnInit {

  addressFormGroup: FormGroup = this.fb.group({
    zipcode: [],
    address: [],
    number: [],
    complement: [],
    neighborhood: [],
    city: [],
    state: []
  });

  formGroup: FormGroup = this.fb.group({
    id: [],
    name: [null, [Validators.required]],
    display_name: [],
    gender: [],
    birthdate: [],
    email: [],
    document_number: [],
    marital_status: [],
    profession: [],
    tags: [],
    phone_numbers: this.fb.array([]),
    health_insurances: this.fb.array([]),
    mother_name: [],
    father_name: [],
    address: this.addressFormGroup,
    clinic: [],
    professional: [],
    ad_origin: [],
    notes: []
  });

  recommendationForm = this.fb.group({
    type: ['clinic']
  });

  submitted = false;
  loadingPage = true;
  searchZipcode: boolean = false;

  imageFile!: File | null;
  changedImage: boolean = false;

  professionsList!: OptionsSelectModel[];
  clinicsList!: OptionsSelectModel[];
  professionalsList!: OptionsSelectModel[];
  allProfessionals: OptionsSelectModel[] = [];
  healthInsurancesList!: OptionsSelectModel[];
  healthInsurancePlans: OptionsSelectModel[] = [];
  patientTagsList!: OptionsSelectModel[];
  phonesList!: PhoneModel[];

  isClinic: boolean = false;
  isPublicity: boolean = false;

  submitting: boolean = false;
  submitButton?: String = "Salvar";

  adOriginList: OptionsSelectModel[] = [
    { label: 'Instagram', value: 'INSTAGRAM' },
    { label: 'Youtube', value: 'YOU_TUBE' },
    { label: 'Site', value: 'SITE' }
  ];

  phoneTypeList: OptionsSelectModel[] = [
    { label: "Whatsapp", value: "WHATSAPP" },
    { label: "Comercial", value: "COMERCIAL" },
    { label: "Residencial", value: "RESIDENTIAL" },
  ];

  maritalStatusList: OptionsSelectModel[] = [
    { value: "MARRIED", label: "Casado" },
    { value: "SINGLE", label: "Solteiro" },
    { value: "DIVORCED", label: "Divorciado" },
    { value: "WIDOWED", label: "Viúvo" }
  ];

  constructor(@Inject(DOCUMENT) private document: Document, private router: Router, private professionService: ProfessionsService, private professionalService: ProfessionalsService, private registersService: RegistersService, private clinicsService: ClinicsService,
    private brApiService: BrapiService, private fb: FormBuilder, private toast: ToastrService) {
  }

  ngOnInit(): void {
    this.addHealthInsurance();
    this.addPhoneNumber();
    this.initializeForm();
  }

  initializeForm() {
    this.fetchProfessionsList();
    this.fetchClinicsList();
    this.fetchProfessionalsList();
    this.fetchHealthInsurancesList();
    this.fetchPatientTags();
    this.loadingPage = false;
  }

  fetchProfessionsList() {
    this.professionService.listAll().subscribe(response => {
      this.professionsList = response.map(item => {
        return {
          label: item.name,
          value: item.name
        } as OptionsSelectModel;
      });
    });
  }

  fetchClinicsList() {
    this.clinicsService.listAll().subscribe(response => {
      this.clinicsList = response.map(item => {
        return {
          label: item.name,
          value: item.id!.toString(),
          item: item
        } as OptionsSelectModel;
      });
    });
  }

  fetchProfessionalsList() {
    this.professionalService.listAll().subscribe(response => {
      this.allProfessionals = response.map(item => {
        return {
          label: `${item.name} - CRO ${item.cro}`,
          value: item.id!.toString()
        } as OptionsSelectModel;
      });
    });
  }

  fetchHealthInsurancesList() {
    this.registersService.listAllHealthInsurances().subscribe(response => {
      this.healthInsurancesList = response.map(item => {
        return {
          label: item.name,
          value: item.id!.toString(),
          item: item
        } as OptionsSelectModel;
      });
    });
  }

  fetchPatientTags() {
    this.registersService.listAllPatientTags().subscribe(response => {
      this.patientTagsList = response.map(item => {
        return {
          label: item.name,
          value: item.id!.toString()
        } as OptionsSelectModel;
      });
    });
  }

  onImageSelect(file: any) {
    this.imageFile = file;
    this.changedImage = true
  }

  handleZipCodeChange(ev: any) {
    this.searchZipcode = true;
    let zipcode = this.addressFormGroup.get('zipcode')?.value;
    this.addressFormGroup.disable();
    this.brApiService.getAddressByZipCode(zipcode).subscribe(response => {
      this.addressFormGroup.patchValue({
        address: response.street,
        neighborhood: response.neighborhood,
        city: response.city,
        state: response.state
      });
      this.searchZipcode = false;
      this.addressFormGroup.enable();
    }, (error: HttpErrorResponse) => {
      this.addressFormGroup.get('zipcode')?.setErrors({ response: 'Cep não encontrado' });
      this.searchZipcode = false;
      this.addressFormGroup.enable();
    });
  }

  cancelHandler() {
    this.router.navigate(['/dashboard/patients']);
  }

  submitHandler() {
    this.formGroup.markAllAsTouched();
    this.submitting = true;
    (this.phoneNumberForms?.value as PhoneModel[]).forEach((phone, index) => {
      if (phone.id == null) this.phoneNumberForms.at(index)?.get('id')?.setValue(undefined);
    });
    (this.healthInsuranceForms?.value as HealthInsurancePatientModel[]).forEach((health, index) => {
      if (health.health_insurance_plan == null) this.healthInsuranceForms.removeAt(index);
      if (health.id == null) this.healthInsuranceForms.at(index)?.get('id')?.setValue(undefined);
    });
    let patientData = this.formGroup.getRawValue() as PatientModel;
    if (this.recommendationForm.get('type')!.value == 'clinic') {
      patientData.ad_origin = undefined;
    } else {
      patientData.clinic = undefined;
      patientData.professional = undefined;
    }
    patientData.tags = patientData.tags ?? [];
    patientData.is_active = true;

    this.registersService.patientRegister(patientData).subscribe(response => {
      if (this.changedImage) {
        this.registersService.uploadPatientImage(this.imageFile!, response.id!).subscribe(res => { }, (errorResponse: HttpErrorResponse) => {
          this.mapErrorResponse(errorResponse);
          this.submitting = false;
        });
      }
      this.submitted = true;
      this.toast.success("Paciente criado com sucesso", "Sucesso");
      this.router.navigate(['/dashboard/patients/']);
    }, (errorResponse: HttpErrorResponse) => {
      this.submitting = false;
      this.mapErrorResponse(errorResponse);
    });
  }

  changeHealthInsurancePlans(healthInsurance: HealthInsuranceModel) {
    this.healthInsurancePlans = healthInsurance.plans?.map(item => {
      return {
        label: item.name,
        value: item.id!.toString()
      } as OptionsSelectModel
    }) || [];
  }

  getHealthInsurancePlansFrom(formGroupIndex: number): OptionsSelectModel[] {
    let formGroup = this.healthInsuranceForms.controls[formGroupIndex] as FormGroup;
    let healthInsuranceId = formGroup.get('health_insurance_id')?.value;
    if (this.healthInsurancesList) {
      let healthInsurance = this.healthInsurancesList.find(healthInsurance => healthInsurance.value == healthInsuranceId)?.item;
      if (healthInsurance) {
        let plans = healthInsurance.plans?.map((item: HealthInsurancePlanModel) => {
          return {
            label: item.name,
            value: item.id?.toString()
          } as OptionsSelectModel;
        }) || [];
        return plans;
      }
    }
    return [];
  }

  getProfessionalsFromClinic(clinic: any) {
    if (!clinic) {
      this.professionalsList = [];
      this.formGroup.get('professional')?.reset();
    } else {
      clinic = this.clinicsList.find(item => item.value == clinic)?.item ;
      let professionalsList = this.allProfessionals.filter(item => clinic.professionals.indexOf(Number(item.value)) != -1);
      this.professionalsList = professionalsList;
    }
  }

  get healthInsuranceForms() {
    return this.formGroup.get('health_insurances') as FormArray;
  }

  getHealthInsuranceForm(index: number) {
    return this.healthInsuranceForms.controls[index] as FormGroup;
  }

  get phoneNumberForms() {
    return this.formGroup.get('phone_numbers') as FormArray;
  }

  getPhoneNumberForm(index: number) {
    return this.phoneNumberForms.controls[index] as FormGroup;
  }

  addPhoneNumber() {
    let phoneNumberFormGroup = this.fb.group({
      id: [],
      country_code: ['+55'],
      phone_number: [],
      type: ['WHATSAPP'],
      is_active: [true]
    });

    this.phoneNumberForms.push(phoneNumberFormGroup);
  }

  addHealthInsurance() {
    let healthInsuranceFormGroup = this.fb.group({
      id: [],
      health_insurance_id: [],
      health_insurance_plan: [],
      number: [],
      is_active: [true]
    });
    this.healthInsuranceForms.push(healthInsuranceFormGroup);
  }

  removeHealthInsurance(at: number) {
    let formGroup = this.healthInsuranceForms.controls[at] as FormGroup;
    if (formGroup.get('id')?.value) {
      formGroup.patchValue({ is_active: false });
    } else {
      this.healthInsuranceForms.removeAt(at);
    }
  }

  removePhoneNumber(at: number) {
    let formGroup = this.phoneNumberForms.controls[at] as FormGroup;
    if (formGroup.get('id')?.value) {
      formGroup.patchValue({ is_active: false });
    } else {
      this.phoneNumberForms.removeAt(at);
    }
  }

  healthInsuranceIsActive(index: number) {
    let formGroup = this.healthInsuranceForms.controls[index] as FormGroup;
    return formGroup.get('is_active')?.value;
  }

  phoneNumberIsActive(index: number) {
    let formGroup = this.phoneNumberForms.controls[index] as FormGroup;
    return formGroup.get('is_active')?.value;
  }

  mapErrorResponse(errorResponse: HttpErrorResponse) {
    if (errorResponse.error["detail"]) {
      this.toast.error(errorResponse.error["detail"], "Erro");
    } else {
      this.setFormErrors(errorResponse);
    }
    this.document.getElementById('main-container')?.scroll({ top: 0 });
  }

  setFormErrors(errorResponse: HttpErrorResponse) {
    let errNames = [
      "name", "display_name", "gender", "birthdate",
      "email", "document_number", "marital_status", "profession",
      "tags", "health_insurances", "phone_numbers", "mother_name",
      "father_name", "clinic", "professional", "ad_origin"
    ];
    errNames.forEach(name => {
      if (errorResponse.error[name])
        this.formGroup.get(name)?.setErrors({ response: errorResponse.error[name] });
    });

    if (errorResponse.error.phone_numbers) {
      let phone_numbers: [] = errorResponse.error.phone_numbers;
      phone_numbers.map((res, index) => {
        let formGroupPhone = this.phoneNumberForms.controls[index] as FormGroup;
        if (res["phone_number"])
          formGroupPhone.get('phone_number')?.setErrors({ response: res["phone_number"] });
        else {
          if (res["country_code"])
            formGroupPhone.get('phone_number')?.setErrors({ response: res["country_code"] });
          else {
            if (res["type"])
              formGroupPhone.get('phone_number')?.setErrors({ response: res["type"] });
          }
        }
      });
    }
  }

  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    return true;
  };

}
